/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to update an existing estimate.
 * @export
 * @interface UpdateEstimateRequest
 */
export interface UpdateEstimateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateEstimateRequest
     */
    sourceSystem?: UpdateEstimateRequestSourceSystemEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateEstimateRequest
     */
    kind?: UpdateEstimateRequestKindEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateEstimateRequest
     */
    subtotalCents?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateEstimateRequest
     */
    taxesCents?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateEstimateRequest
     */
    depreciationCents?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateEstimateRequest
     */
    totalCents?: number;
}


/**
 * @export
 */
export const UpdateEstimateRequestSourceSystemEnum = {
    Xactimate: 'xactimate',
    Symbility: 'symbility',
    Other: 'other'
} as const;
export type UpdateEstimateRequestSourceSystemEnum = typeof UpdateEstimateRequestSourceSystemEnum[keyof typeof UpdateEstimateRequestSourceSystemEnum];

/**
 * @export
 */
export const UpdateEstimateRequestKindEnum = {
    Insurer: 'insurer',
    Contractor: 'contractor'
} as const;
export type UpdateEstimateRequestKindEnum = typeof UpdateEstimateRequestKindEnum[keyof typeof UpdateEstimateRequestKindEnum];


/**
 * Check if a given object implements the UpdateEstimateRequest interface.
 */
export function instanceOfUpdateEstimateRequest(value: object): value is UpdateEstimateRequest {
    return true;
}

export function UpdateEstimateRequestFromJSON(json: any): UpdateEstimateRequest {
    return UpdateEstimateRequestFromJSONTyped(json, false);
}

export function UpdateEstimateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEstimateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'kind': json['kind'] == null ? undefined : json['kind'],
        'subtotalCents': json['subtotalCents'] == null ? undefined : json['subtotalCents'],
        'taxesCents': json['taxesCents'] == null ? undefined : json['taxesCents'],
        'depreciationCents': json['depreciationCents'] == null ? undefined : json['depreciationCents'],
        'totalCents': json['totalCents'] == null ? undefined : json['totalCents'],
    };
}

export function UpdateEstimateRequestToJSON(json: any): UpdateEstimateRequest {
    return UpdateEstimateRequestToJSONTyped(json, false);
}

export function UpdateEstimateRequestToJSONTyped(value?: UpdateEstimateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceSystem': value['sourceSystem'],
        'kind': value['kind'],
        'subtotalCents': value['subtotalCents'],
        'taxesCents': value['taxesCents'],
        'depreciationCents': value['depreciationCents'],
        'totalCents': value['totalCents'],
    };
}

